
import AdminLayout from "@/components/admin/AdminLayout";
import { useAdminSettings } from "@/hooks/useAdminSettings";
import AdminSettingsHeader from "@/components/admin/settings/AdminSettingsHeader";
import SettingsTabs from "@/components/admin/settings/SettingsTabs";

const AdminSettings = () => {
  const {
    loading,
    settings,
    hasChanges,
    handleSettingsChange,
    handleSave,
    handleReset,
  } = useAdminSettings();

  if (loading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-64">
          <div className="text-muted-foreground">Loading settings...</div>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="space-y-6">
        <AdminSettingsHeader
          hasChanges={hasChanges}
          onSave={handleSave}
          onReset={handleReset}
        />
        <SettingsTabs
          settings={settings}
          onSettingsChange={handleSettingsChange}
        />
      </div>
    </AdminLayout>
  );
};

export default AdminSettings;
